import React from 'react';
import './GradientButtonCourse.css'; // External CSS for better management

interface GradientButtonCourseProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  width?: string; // Allow customizable width
  onPress?: () => void; // Optional onPress handler
}

const GradientButtonCourse: React.FC<GradientButtonCourseProps> = ({ children, width = '100%', onPress, ...props }) => {
  return (
    <button
      {...props}
      className="gradient-button-course"
      style={{ width }} // Dynamically set width if provided
      onClick={onPress} // Map onPress to the button's onClick
    >
      <span className='btn-text'>{children}</span> {/* Ensure consistent text structure */}
    </button>
  );
};

export default GradientButtonCourse;
